const railsErrorToMessage = (error) => {
  console.log(error.response.data);
  const message = error.response.data;
  if (typeof message === 'string') {
    return message;
  }

  // Handle ActiveRecord-style validation errors object
  return Object.entries(message)
    .map(([field, errors]) => `${field.split('_').join(' ').charAt(0).toUpperCase() + field.split('_').join(' ').slice(1)} ${errors.join(', ')}`)
    .join('. ');
};

// A rejected API action answers with { error: "..." }, and sometimes the same
// content unjoined in `errors`. Anything else -- a network failure, a 500, an
// HTML error page -- carries nothing worth showing a player, so the caller's
// fallback stands.
const apiErrorMessage = (error, fallback) => {
  const data = error?.response?.data;

  if (typeof data?.error === 'string' && data.error.trim()) {
    return data.error;
  }

  if (Array.isArray(data?.errors) && data.errors.length) {
    return data.errors.join(' ');
  }

  return fallback;
};

export { railsErrorToMessage, apiErrorMessage };
